/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Participant_Status_ActiveInputs */



/**
* | output |
* | --- |
* | "Active" |
*
* @param {Tournaments_Lib_Participant_Status_ActiveInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_participant_status_active = /** @type {((inputs?: Tournaments_Lib_Participant_Status_ActiveInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Participant_Status_ActiveInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktiv")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Actif")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("参赛中")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("參賽中")
	if (locale === "ko") return /** @type {LocalizedString} */ ("참가 중")
	return /** @type {LocalizedString} */ ("Active")
});